/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Account_TitleInputs */

const vi_shop_account_title = /** @type {(inputs: Shop_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản khách`)
};

/**

* @param {Shop_Account_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_account_title = /** @type {((inputs?: Shop_Account_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Account_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_account_title(inputs)
});